import SchoolRegisterModal from '~/components/modals/SchoolRegisterModal.vue'

export const links: {
  title: string
  href?: string
  to?: string
}[] = [
  { title: 'Направления', to: '/directions' },
  { title: 'Новости', to: '/news' },
  { title: 'Школы', to: '/schools' },
  { title: 'Тренеры', to: '/trainers' },
  // { title: 'Соревнования', href: '#' },
]

export const CARDS = [
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
  {},
]

export const ORGANIZATION_DATA = {
  title: 'Код спорта',
  slogan: 'ваш путь к победам',
  description:
    'Единая платформа для спортивных школ, тренеров и федераций России',
  shortDescription: 'Единая платформа спорта России',
  phone: '+7 (495) 123-45-67',
  email: 'info@sportportal.ru',
  workTime: 'Пн-Пт 08:00 - 18:00',
}

export const FOOTER_MENU = [
  {
    title: 'Для спортсменов',
    links: [
      { label: 'Направления', href: '/directions' },
      { label: 'Новости', href: '/news' },
      // { label: 'Соревнования', href: '/' },
      { label: 'О проекте', href: '#' },
    ],
  },
  {
    title: 'Для организаций',
    links: [
      {
        label: 'Моковая регистрация школы',
        href: '#',
        onClick: () => {
          const overlay = useOverlay()
          const schoolRegisterModal = overlay.create(SchoolRegisterModal)
          schoolRegisterModal.open()
        },
      },
      { label: 'Моковая регистрация тренера', href: '#' },
      { label: 'Документация', href: '/documents' },
    ],
  },
]
